import React from 'react'; // eslint-disable-line import/no-unresolved, import/no-extraneous-dependencies
import './loading-stub.css';

const LoadingStubHotel = () => (
    <div>
        <div
            id="loading-stub"
            className="odf-box odf-space-inner-m odf-position-relative"
            style={{
                marginTop: '44px',
            }}
        >
            <div className="odf-flex-container-row">
                <div
                    className="odf-input-group odf-flex-item odf-flex-item-span-12"
                >
                    <input
                        type="text"
                        style={{
                            borderRadius: 8,
                            height: '44px',
                            background: '#F2F2F2',
                            border: 'none',
                        }}
                        className="odf-input-l odf-text-lg odf-input odf-clickable odf-text-ellipsis"
                        disabled
                    />
                </div>
            </div>
            <div className="odf-space-outer-top-s" />
            <div
                className="odf-space-outer-top-m odf-flex-container-row odf-flex-container-justify-end
                           odf-space-inner-left-m odf-space-inner-right-m"
            >
                <button
                    type="button"
                    style={{
                        borderRadius: 28,
                        height: 44,
                        background: '#F2F2F2',
                        border: 'none',
                    }}
                    className="odf-btn odf-btn-xl-flex odf-btn-block odf-btn-primary odf-input-fixed-l"
                />
            </div>
        </div>
    </div>
);

export default LoadingStubHotel;
